import { render } from "./Info_membre.vue?vue&type=template&id=2ec31488&scoped=true"
import script from "./Info_membre.vue?vue&type=script&lang=js"
export * from "./Info_membre.vue?vue&type=script&lang=js"

import "../assets/css/info.css?vue&type=style&index=0&id=2ec31488&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec31488"]])

export default __exports__